/**
 * PDP Smoothness Before / After Interactive Draggable Comparison Slider
 */
(function() {
  function initBeforeAfterSliders() {
    var containers = document.querySelectorAll('.pdp-ba-container:not([data-initialized="true"])');

    containers.forEach(function(container) {
      container.setAttribute('data-initialized', 'true');
      var beforeLayer = container.querySelector('.pdp-ba-layer--before');
      var innerImage = container.querySelector('.pdp-ba-layer__inner');
      var handle = container.querySelector('.pdp-ba-handle');

      if (!beforeLayer || !handle) return;

      var isDragging = false;
      var ratioSetting = container.getAttribute('data-aspect-ratio') || 'auto';
      var targetImg = container.querySelector('.pdp-ba-layer--after img') || container.querySelector('.pdp-ba-layer--before img') || container.querySelector('img');

      function applyAspectRatio() {
        if (ratioSetting === 'auto' && targetImg) {
          if (targetImg.naturalWidth > 0 && targetImg.naturalHeight > 0) {
            container.style.aspectRatio = targetImg.naturalWidth + ' / ' + targetImg.naturalHeight;
            updateDimensions();
          }
        } else if (ratioSetting && ratioSetting !== 'auto') {
          container.style.aspectRatio = ratioSetting;
          updateDimensions();
        }
      }

      if (targetImg) {
        if (targetImg.complete && targetImg.naturalWidth > 0) {
          applyAspectRatio();
        } else {
          targetImg.addEventListener('load', function() {
            applyAspectRatio();
            updateDimensions();
          });
        }
      }

      function updateDimensions() {
        var rect = container.getBoundingClientRect();
        if (rect.width > 0 && innerImage) {
          innerImage.style.width = rect.width + 'px';
        }
      }

      function setPosition(percentage) {
        // Clamp between 2% and 98% to keep handle always within view
        percentage = Math.max(2, Math.min(98, percentage));
        beforeLayer.style.width = percentage + '%';
        handle.style.left = percentage + '%';
        container.setAttribute('aria-valuenow', Math.round(percentage));
      }

      function handleMove(clientX) {
        var rect = container.getBoundingClientRect();
        if (rect.width <= 0) return;
        var offsetX = clientX - rect.left;
        var percentage = (offsetX / rect.width) * 100;
        setPosition(percentage);
      }

      // Pointer event handlers (Universal support for Mouse, Touch, and Stylus)
      if (window.PointerEvent) {
        container.addEventListener('pointerdown', function(e) {
          isDragging = true;
          container.classList.add('is-dragging');
          container.setPointerCapture(e.pointerId);
          updateDimensions();
          handleMove(e.clientX);
          e.preventDefault();
        });

        container.addEventListener('pointermove', function(e) {
          if (!isDragging) return;
          handleMove(e.clientX);
        });

        container.addEventListener('pointerup', function(e) {
          if (isDragging) {
            isDragging = false;
            container.classList.remove('is-dragging');
            try {
              container.releasePointerCapture(e.pointerId);
            } catch (err) {}
          }
        });

        container.addEventListener('pointercancel', function(e) {
          if (isDragging) {
            isDragging = false;
            container.classList.remove('is-dragging');
          }
        });
      } else {
        // Legacy Touch & Mouse fallback
        function onTouchStart(e) {
          isDragging = true;
          container.classList.add('is-dragging');
          updateDimensions();
          var clientX = e.clientX || (e.touches && e.touches[0] ? e.touches[0].clientX : 0);
          handleMove(clientX);
          e.preventDefault();
        }

        function onTouchMove(e) {
          if (!isDragging) return;
          var clientX = e.clientX;
          if (e.touches && e.touches[0]) {
            clientX = e.touches[0].clientX;
          }
          handleMove(clientX);
        }

        function onTouchEnd() {
          if (isDragging) {
            isDragging = false;
            container.classList.remove('is-dragging');
          }
        }

        container.addEventListener('mousedown', onTouchStart);
        container.addEventListener('touchstart', onTouchStart, { passive: false });

        window.addEventListener('mousemove', onTouchMove);
        window.addEventListener('touchmove', onTouchMove, { passive: true });

        window.addEventListener('mouseup', onTouchEnd);
        window.addEventListener('touchend', onTouchEnd);
        window.addEventListener('touchcancel', onTouchEnd);
      }

      // Keyboard Accessibility
      container.setAttribute('tabindex', '0');
      container.setAttribute('role', 'slider');
      container.setAttribute('aria-label', 'Before and after comparison slider');
      container.setAttribute('aria-valuenow', '50');
      container.setAttribute('aria-valuemin', '0');
      container.setAttribute('aria-valuemax', '100');

      container.addEventListener('keydown', function(e) {
        var currentWidth = parseFloat(beforeLayer.style.width) || 50;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
          setPosition(currentWidth - 5);
          e.preventDefault();
        } else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
          setPosition(currentWidth + 5);
          e.preventDefault();
        }
      });

      // Window resize handler for exact alignment
      window.addEventListener('resize', updateDimensions);

      // Initialize size & default 50% split position
      updateDimensions();
      setPosition(50);

      // In case images take time to load or layout shifts
      var images = container.querySelectorAll('img');
      images.forEach(function(img) {
        if (!img.complete) {
          img.addEventListener('load', updateDimensions);
        }
      });
    });
  }

  // Run on DOMContentLoaded, window load, and on Shopify Theme Editor section load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBeforeAfterSliders);
  } else {
    initBeforeAfterSliders();
  }

  window.addEventListener('load', initBeforeAfterSliders);

  document.addEventListener('shopify:section:load', function(e) {
    var containers = (e.target || document).querySelectorAll('.pdp-ba-container');
    containers.forEach(function(c) {
      c.removeAttribute('data-initialized');
    });
    initBeforeAfterSliders();
  });

  document.addEventListener('shopify:section:select', function(e) {
    var containers = (e.target || document).querySelectorAll('.pdp-ba-container');
    containers.forEach(function(c) {
      c.removeAttribute('data-initialized');
    });
    initBeforeAfterSliders();
  });
})();
